import { Component, ViewChild, AfterViewInit, Input, OnDestroy } from '@angular/core';
import { MatMenuTrigger, MenuPositionX } from '@angular/material/menu';
import { DropdownMenuItem, MojoAbstractDropdownMenuComponent } from 'mojo-abstract-dropdown-menu';
import { MojoBatchService } from 'mojo-batch';

@Component({
  selector: 'mojo-dropdown-menu-with-icons',
  templateUrl: './dropdown-menu-with-icons.component.html',
  styleUrls: ['./dropdown-menu-with-icons.component.scss'],
})
export class DropdownMenuWithIconsComponent
  extends MojoAbstractDropdownMenuComponent
  implements AfterViewInit, OnDestroy
{
  @ViewChild('menuTrigger') matMenuTrigger: MatMenuTrigger;
  @Input()
  xPosition: MenuPositionX = 'after';

  @Input()
  width: string;

  constructor(private batchSelectionManagerService: MojoBatchService) {
    super();
  }

  ngAfterViewInit() {
    this.setMenuTrigger(this.matMenuTrigger);
  }

  onClick(menuItem: DropdownMenuItem) {
    this.batchSelectionManagerService.clearSelection();
    super.onClick(menuItem);
  }
}
